import { formatEventKind, formatTime } from '@car-pool/shared/calendar';

export function getCalendarEventDisplayTime(event) {
  if (!event) return null;
  if (event.kind === 'LATE_START') return event.start_time || null;
  if (event.kind === 'EARLY_RELEASE' || event.kind === 'CUSTOM') {
    return event.end_time || event.start_time || null;
  }
  return null;
}

export function formatCalendarEventTiming(event) {
  if (!event) return '';
  if (event.kind === 'NO_SCHOOL') return 'No School';

  const displayTime = getCalendarEventDisplayTime(event);
  if (event.kind === 'LATE_START') {
    return displayTime ? `Late Start: ${formatTime(displayTime)}` : 'Late Start';
  }
  if (displayTime) return `Dismissal Time: ${formatTime(displayTime)}`;
  return formatEventKind(event.kind);
}
